import axios from 'axios'
import { APIHOST } from "@/settings";
import SessionStorage from "sessionstorage";

class BranchService {
    getAll() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${APIHOST}/api/branch`, {
            headers: { 'Authorization': `Bearer ${oAuthAccess.access_token}` }
        })
    }

    getCompanyBranches(inn) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${APIHOST}/api/branch`, {
            headers: { 'Authorization': `Bearer ${oAuthAccess.access_token}` },
            params: {id: inn}
        })
    }
}

export default new BranchService();